import script from "./Respaldo.vue?vue&type=script&setup=true&lang=js"
export * from "./Respaldo.vue?vue&type=script&setup=true&lang=js"

import "./Respaldo.vue?vue&type=style&index=0&id=0f88df8f&scoped=true&lang=css"
import "./Respaldo.vue?vue&type=style&index=1&id=0f88df8f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f88df8f"]])

export default __exports__